import {doc} from './docs.js';

doc(
    "split",
    {
        min: "min",
        max: "max"
    },
    "Sends incoming msgs that are within a range out the left-inlet, and the rest through the right.",
    undefined,
    {
        tags: "Messages"
    }
);


export const split = (zobject, min, max) => {
    return (msg) => {
        msg = msg[0];

        if (min() <= msg && msg <= max()) {
            return [msg];
        } else {
            return [undefined, msg];
        }
    };
}
 
